module.exports = __webpack_public_path__ + "img/arrow-orange.e2c5a508.svg";